<template>
  <div class="log" :style="logStyle">
    <avue-crud :option="option"
               :data="data"
               :page="page"
               ref="crud"
               @search-change="searchChange"
               @search-reset="refreshChange"
               @size-change="sizeChange"
               @current-change="currentChange"
               @refresh-change="refreshChange"
               @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary"
                   icon="el-icon-user"
                   @click="getLogin"
                   size="mini">登录日志
        </el-button>
        <el-button type="primary"
                   icon="el-icon-notebook-2"
                   @click="getToken"
                   size="mini">令牌日志
        </el-button>
        <el-button type="primary"
                   icon="el-icon-download"
                   @click="getPackage"
                   size="mini">拉取日志
        </el-button>
        <el-button type="danger"
                   icon="el-icon-document"
                   @click="$router.push({path:'/pay-list'})"
                   size="mini">订单管理
        </el-button>
        <el-button type="warning"
                   icon="el-icon-cpu"
                   @click="judgeWaring"
                   size="mini">异常研判
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   icon="el-icon-setting"
                   @click="setBuild(scope.row)"
                   size="small">用户信息
        </el-button>
      </template>
    </avue-crud>
    <auth ref="auth"
          @submit="getLogin">
    </auth>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import Record from '@/util/record'

export default {
  data() {
    return {
      sliderVisible: true, // 控制slider的显示
      data: [],
      selectlist: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSizes: [10, 30, 50, 100, 200, 1000],
        pageSize: 10
      },
      params: {},
      logType: 1,
      option: {
        size: 'mini',
        align: "center",
        menuAlign: 'left',
        headerAlign: 'center',
        index: true,
        excelBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        viewBtn: true,
        editBtn: false,
        tip: false,
        menuWidth: 150,
        column: [{
          label: 'uid',
          prop: 'uid',
          width: 80,
        }, {
          label: '账号',
          prop: 'user_name',
          width: 100,
          search: true,
        }, {
          label: 'ip',
          prop: 'login_ip',
          width: 120,
          search: true,
        }, {
          label: '日期',
          prop: "login_time",
          width: 150,
        }, {
          label: '地区',
          prop: "area",
          width: 130,
        }, {
          label: '运营商',
          prop: 'isp',
          width: 100,
        }, {
          label: '代理',
          prop: 'user_agent',
          width: 500,
        }, {
          label: 'token',
          prop: 'token',
          search: true,
        }, {
          label: '依赖信息',
          prop: 'package',
        }]
      },
    }
  },
  mounted() {
    this.getLogin()
  },
  computed: {
    logStyle() {
      // 根据 sliderVisible 状态返回不同的 padding
      return this.sliderVisible
        ? { padding: '100px 10px 100px 10px' } // 默认 padding
        : { padding: '200px 10px 100px 10px' }; // slider 隐藏时的 padding
    },
    ...mapState(['user', 'pwd']),
  },
  created () {
    const handleResize = () => {
      this.sliderVisible = window.innerWidth > 768;
    };
    handleResize(); // 确保首次加载时执行
    window.addEventListener('resize', () => {
      this.sliderVisible = window.innerWidth > 768;
      this.$forceUpdate(); // 强制更新视图
    });
  },
  methods: {
    searchChange(params) {
      this.getList(Object.assign(params, this.params))
    },
    selectionChange(list) {
      this.selectlist = list;
    },
    getLogin() {
      this.page.currentPage = 1;
      this.getList({logType: 1})
    },
    getToken() {
      this.page.currentPage = 1;
      this.getList({logType: 2})
    },
    judgeWaring() {

    },
    getPackage() {
      this.page.currentPage = 1;
      this.getList({logType: 3})
    },
    setBuild(row) {
      window.open(`https://center.javablade.com/admin/users/${row.uid}/edit`, '_blank')
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.getList(this.params)
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList(this.params)
    },
    refreshChange() {
      this.data = [];
      this.params = {};
      this.$message.success('刷新成功')
      this.getList(this.params);
    },
    getList(params) {
      if (this.validatenull(this.pwd)) return;
      if (this.user !== 'bladex') return;

      this.params = params;
      this.logType = params.logType;

      let table = 'gitea_login_log';
      if (this.logType === 2) {
        table = 'gitea_access_token_log';
      } else if (this.logType === 3) {
        table = 'gitea_pull_package_log';
      }

      const query = new Record(table);
      query.count().then(res => {
        this.page.total = res.data;
        const next = (this.page.currentPage - 1) * this.page.pageSize;
        query.limit(this.page.pageSize)
        query.skip(next)
        query.order("-id");
        for (let o in params) {
          if (o === 'logType') continue;
          query.equalTo(o, " like ", `'%${params[o]}%'`);
        }
        return query.find()
      }).then(res => {
        const data = res.data;
        data.forEach(d => {
          if (this.logType === 3) {
            d.login_time = this.formatTimestamp(d.pull_time);
          } else {
            d.login_time = this.formatTimestamp(d.login_time);
          }
          d.area = this.getAreaInfo(d);
          d.token = this.getTokenInfo(d);
          d.package = this.getPackageInfo(d);
        })
        this.data = data;

      });
    },
    getAreaInfo(data) {
      return `${data.country}/${data.province}/${data.city}`;
    },
    getTokenInfo(data) {
      if (this.logType !== 1) {
        return data.token;
      } else {
        return "-";
      }
    },
    getPackageInfo(data) {
      if (this.logType === 3) {
        return `${data.package_type}:${data.package_name}@${data.package_version}`;
      } else {
        return "-";
      }
    },
    // 将时间戳转换为格式化的字符串
    formatTimestamp(timestamp) {
      // 将秒级时间戳转换为毫秒级
      const date = new Date(timestamp * 1000);
      // 使用Intl.DateTimeFormat来格式化日期
      const formatter = new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // 使用24小时制
      });
      return formatter.format(date);
    }
  },
}
</script>

<style lang="scss">
.log {
  min-height: 700px;
}

input[type=number] {
  width: 35px !important;
}
</style>
